import { ArsTableGroup } from "../interface";
import { isArsTableOperation } from "./isArsTableOperation";
import { isArsTableSubGroup } from "./isArsTableSubGroup";

/**
 * Type guard for ArsTableGroup, which can be either an ArsTableSubGroup or an ArsTableOperation.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the group/operation label
 * @returns True if the object is an ArsTableGroup, false otherwise
 */
export const isArsTableGroup = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableGroup<T> => isArsTableSubGroup(obj, isT) || isArsTableOperation(obj, isT);
